import { SxlEvaluator } from '@saviynt/savxl';
import { type FormikTouched } from 'formik';

import { type FormValues } from '../../../shared/types';
import { type EntityInitialData } from '../../FormPreview/data-store/initialDataSlice';

interface EvaluationContext {
  values: FormValues;
  touched: FormikTouched<FormValues>;
  entityData: EntityInitialData | null;
}

// Single evaluator instance for performance
const evaluator = new SxlEvaluator();

export function evaluateExpressionValue(
  expression: string,
  context: EvaluationContext
): string {
  if (!expression.trim()) {
    return '';
  }

  try {
    // Clear previous variables for clean state
    evaluator.clearVariables();

    // Set current form values as variables
    Object.entries(context.values).forEach(([key, value]) => {
      evaluator.setVariable(key, value);
    });

    // Set entity data variables safely
    if (context.entityData) {
      Object.entries(context.entityData).forEach(([key, value]) => {
        if (value) {
          evaluator.setVariable(key, value);
        }
      });
    }

    // Use type-safe boolean evaluation
    return evaluator.evaluateAs(expression, 'string');
  } catch {
    return ''; // Fallback to safe default
  }
}

/**
 * Evaluate expression for field visibility/requirements using SAVXL
 */
export function evaluateExpression(
  expression: string,
  context: EvaluationContext
): boolean {
  if (!expression.trim()) {
    return true;
  }

  // Only evaluate if at least one referenced field has a value
  // if (!hasValidFieldValues(expression, context)) {
  //   return false;
  // }

  try {
    // Clear previous variables for clean state
    evaluator.clearVariables();

    // Set current form values as variables
    Object.entries(context.values).forEach(([key, value]) => {
      evaluator.setVariable(key, value);
    });

    // Set entity data variables safely
    if (context.entityData) {
      Object.entries(context.entityData).forEach(([key, value]) => {
        if (value) {
          evaluator.setVariable(key, value);
        }
      });
    }

    // Use type-safe boolean evaluation
    const result = evaluator.evaluateAs(expression, 'boolean');

    return result;
  } catch (e) {
    return false; // Fallback to safe default
  }
}
